"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@gogame/ui/utils");
var _xDataGrid = require("@mui/x-data-grid");
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _constants = require("../../constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var dataCy = exports.dataCy = 'DataGrid-cell-wrapper';

// const TraceUpdates = React.forwardRef((props, ref) => {
//   const { TracedComponent, ...other } = props;
//   const rootRef = React.useRef(null);
//   const handleRef = useForkRef(rootRef, ref);
//
//   React.useEffect(() => {
//     const root = rootRef.current;
//     root.style.backgroundColor = 'rgb(92 199 68 / 20%)';
//
//     const timer = setTimeout(() => {
//       root.style.backgroundColor = '';
//     }, 360);
//
//     return () => {
//       clearTimeout(timer);
//     };
//   });
//
//   return <TracedComponent ref={handleRef} {...other} />;
// });
//
// const FastCellFastCell = React.forwardRef((props, ref) => {
//   const { FastComponent, ...other } = props;
//   const [mounted, setMounted] = React.useState();
//
//   React.useEffect(() => {
//     const timer = setTimeout(() => {
//       setMounted(true);
//     }, 200);
//     return () => {
//       clearTimeout(timer);
//     };
//   }, []);
//
//   if (!mounted) {
//     return null;
//   }
//   return <FastComponent ref={ref} {...other} />;
// });

var GGGridCell = function GGGridCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var column = props.column;
  // return (
  //   <FastCell
  //     FastComponent={GridCell}
  //     // TracedComponent={GridCell}
  //     {...props}
  //     data-cy={dataCy}
  //     aria-label={column.headerName}
  //   />
  // );
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_xDataGrid.GridCell, _objectSpread(_objectSpread({}, props), {}, {
    "data-cy": dataCy,
    "data-cy-tree-data-group": column.field === _xDataGridPro.GRID_TREE_DATA_GROUPING_FIELD ? true : null,
    "aria-label": column.headerName,
    "data-cy-field": column.field
  }));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(GGGridCell, _constants.compareProps); // prevent  extra rendering after scrolling on Windows OS